import React, { useState, useEffect } from 'react';
import Btn from '../../../Components/Btn';
import Modal from '../../../Components/Modal';
import ModalHeader from '../../../Components/ModalHeader';
import ModalBody from '../../../Components/ModalBody';
import ModalFooter from '../../../Components/ModalFooter';
import InputCustom from '../../../Components/InputCustom';
import PopinConfirm from '../../../Components/PopinConfirm';
import CodeSnippet from '../../../Components/CodeSnippet';


type EmailRemarketingStateModalType = {
	isOpened: boolean,
	handleClose: () => void,
	getEmailRemarketingState: (email: string, callbackSuccess: ((data: any) => void)) => void,
	resetEmailRemarketingState: (email: string, callbackSuccess?: () => void) => void
}

export default function EmailRemarketingStateModal({
	isOpened,
	handleClose,
	getEmailRemarketingState,
	resetEmailRemarketingState
}: EmailRemarketingStateModalType) {

	const [emailIsNotValid, setEmailDataIsNotValid] = useState(false);
	const [email, setEmail] = useState('');
	const [state, setState] = useState(null);
	const [confirmIsOpened, setConfirmIsOpened] = useState(false);

	useEffect(() => {
		if (isOpened) {
			setEmail('');
			setEmailDataIsNotValid(false);
			setState(null);
		}
	}, [isOpened]);

	const getEmailState = () => {
		getEmailRemarketingState(email, data => setState(data));
	};
	const confirmResetEmailState = () => {
		setConfirmIsOpened(true);
	};
	const resetEmailState = () => {
		setConfirmIsOpened(false);
		resetEmailRemarketingState(email, () => getEmailState());
	};
	const handleChangeEmail = (e) => {
		e.persist();
		setState(null);
		setEmailDataIsNotValid(false);
		setEmail(e.target.value);
	};

	return (<>
		<Modal
			isOpen={isOpened}
			onClose={() => handleClose()}
		>
			<ModalHeader
				title="View email Data"
			/>
			<ModalBody>
				{confirmIsOpened &&
					<PopinConfirm
						cancel={() => setConfirmIsOpened(false)}
						title={'Are you sure you want to reset state for this address?'}
						message={''}
					>
						<Btn
							onClickFunction={() => { setConfirmIsOpened(false); }}
							message="No"
							color="secondary"
							style="outline"
						/>
						<Btn
							onClickFunction={() => { resetEmailState(); }}
							message="Yes"
							color="alert"
						/>
					</PopinConfirm>
				}
				<InputCustom
					label="Email address"
					onChange={(e) => handleChangeEmail(e)}
					value={email ? email : ''}
					isAnError={emailIsNotValid ? 'This email address is not valid' : ''}
					fullWidth={true}
					placeHolder='email@exemple.com'
				/>
				<Btn
					message='View data'
					onClick={() => { getEmailState(); }}
					disabled={!email}
				/>

				{email && state &&
					<>
						<Btn
							icon="fas fa-trash"
							message='Reset'
							color='alert'
							onClick={() => confirmResetEmailState()}
						/>
						<CodeSnippet code={state ? JSON.stringify(state, null, 3) : ''}></CodeSnippet>
					</>
				}

			</ModalBody>
			<ModalFooter
				primaryAction={
					<Btn
						onClick={() => handleClose()}
						message="Close"
					/>
				}
			/>
		</Modal>
	</>);
}